interface IStrong {
  content: string;
}

export const Strong = ({ content }: IStrong): JSX.Element => {
  return <strong>{content}</strong>;
};
